import * as PIXI from 'pixi.js';
import 'pixi-spine';
import 'pixi-extra-filters';
import 'pixi-particles';
import {translate} from './utils';
import 'babel-polyfill';

import jquery from 'jquery';

import '../libs/p3.min';

import Main from './Main';
global.$ = jquery;

const main = new Main(1024, 768);

WebFont.load({
	custom: {
		families: ['Roboto', 'LuckiestGuy']
	},
	active: function() {
		main.init();
	}
});
